import React from "react";
import { useRefinementList } from "react-instantsearch";
import { translate } from "../../../Services/translation";
import { RefinementPanel } from "./Panel";
import { SizeRefinementListProps } from "./types/CustomRefinementListProps";

const SizeRefinementList = (props: SizeRefinementListProps) => {
  const { searchable = false, searchablePlaceholder } = props;
  const {
    items,
    refine,
    searchForItems,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
    isFromSearch,
  } = useRefinementList(props);
  const nothingToRefine = items.length <= 1 && !isFromSearch;

  return (
    <RefinementPanel
      {...props}
      className={`${nothingToRefine ? "hidden" : ""}`}
    >
      <div className="algolia-size-refinement-list">
        {searchable && (
          <form
            noValidate
            action=""
            role="search"
            className="algolia-size-refinement-list__search-form"
          >
            <input
              className="algolia-size-refinement-list__search-input"
              type="search"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              maxLength={512}
              onChange={(event) => searchForItems(event.currentTarget.value)}
              placeholder={searchablePlaceholder}
            />
          </form>
        )}
        <ul className="algolia-size-refinement-list__items">
          {items.length > 0
            ? items.map((item) => (
                <li
                  className={`algolia-size-refinement-list__items__item ${
                    item.isRefined
                      ? "algolia-size-refinement-list__items__item--checked"
                      : ""
                  }`}
                  key={item.label}
                  data-insights-filter={`${props.attribute}:${item.value}`}
                >
                  <label className="algolia-size-refinement-list__items__item__label">
                    <div className="algolia-size-refinement-list__items__item__checkbox-container">
                      <input
                        className="algolia-size-refinement-list__items__item__checkbox"
                        type="checkbox"
                        checked={item.isRefined}
                        onChange={() => refine(item.value)}
                      />
                      <span>{item.label}</span>
                    </div>
                  </label>
                </li>
              ))
            : isFromSearch && (
                <span className="algolia-size-refinement-list__items__no-results">
                  {translate("algolia.filters.no-results")}
                </span>
              )}
        </ul>
        <button
          onClick={toggleShowMore}
          disabled={!canToggleShowMore}
          className="algolia-size-refinement-list__more-button"
        >
          <span className="algolia-size-refinement-list__more-button__label">
            {isShowingMore
              ? translate("algolia.filters.show-less")
              : translate("algolia.filters.show-more")}
          </span>
        </button>
      </div>
    </RefinementPanel>
  );
};

export default SizeRefinementList;
